// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as HealthPackagesRouteImport } from './routes/health-packages'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HealthArticlesIndexRouteImport } from './routes/health-articles.index'
import { Route as DoctorsIndexRouteImport } from './routes/doctors.index'
import { Route as DepartmentsIndexRouteImport } from './routes/departments.index'
import { Route as HealthArticlesSlugRouteImport } from './routes/health-articles.$slug'
import { Route as DepartmentsNameRouteImport } from './routes/departments.$name'
import { Route as BookNameRouteImport } from './routes/book.$name'
import { Route as AppointmentRefRouteImport } from './routes/appointment.$ref'
import { Route as DoctorsDepartmentNamePractitionerNameRouteImport } from './routes/doctors.$departmentName.$practitionerName'

const HealthPackagesRoute = HealthPackagesRouteImport.update({
            id: '/health-packages',path: '/health-packages',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const HealthArticlesIndexRoute = HealthArticlesIndexRouteImport.update({
            id: '/health-articles/',path: '/health-articles/',getParentRoute: () => rootRouteImport
          })
const DoctorsIndexRoute = DoctorsIndexRouteImport.update({
            id: '/doctors/',path: '/doctors/',getParentRoute: () => rootRouteImport
          })
const DepartmentsIndexRoute = DepartmentsIndexRouteImport.update({
            id: '/departments/',path: '/departments/',getParentRoute: () => rootRouteImport
          })
const HealthArticlesSlugRoute = HealthArticlesSlugRouteImport.update({
            id: '/health-articles/$slug',path: '/health-articles/$slug',getParentRoute: () => rootRouteImport
          })
const DepartmentsNameRoute = DepartmentsNameRouteImport.update({
            id: '/departments/$name',path: '/departments/$name',getParentRoute: () => rootRouteImport
          })
const BookNameRoute = BookNameRouteImport.update({
            id: '/book/$name',path: '/book/$name',getParentRoute: () => rootRouteImport
          })
const AppointmentRefRoute = AppointmentRefRouteImport.update({
            id: '/appointment/$ref',path: '/appointment/$ref',getParentRoute: () => rootRouteImport
          })
const DoctorsDepartmentNamePractitionerNameRoute = DoctorsDepartmentNamePractitionerNameRouteImport.update({
            id: '/doctors/$departmentName/$practitionerName',path: '/doctors/$departmentName/$practitionerName',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,HealthPackagesRoute: HealthPackagesRoute,AppointmentRefRoute: AppointmentRefRoute,BookNameRoute: BookNameRoute,DepartmentsNameRoute: DepartmentsNameRoute,HealthArticlesSlugRoute: HealthArticlesSlugRoute,DepartmentsIndexRoute: DepartmentsIndexRoute,DoctorsIndexRoute: DoctorsIndexRoute,HealthArticlesIndexRoute: HealthArticlesIndexRoute,DoctorsDepartmentNamePractitionerNameRoute: DoctorsDepartmentNamePractitionerNameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)